import React from 'react'
import { shallow } from 'enzyme'

import Tabs from '../Tabs'

describe('Tabs', () => { 
  let wrapper, props, instance

  beforeAll(() => {
    props = {
      loan: {
        businesses: [
          {
            borrowerType: 'oc',
            name: 'name',
            guarantors: [],
            seniorStaff: []
          }
        ]
      },
      isEditable: true,
      isEligibility: true,
    }
    wrapper = shallow(<Tabs {...props} />)
    instance = wrapper.instance()
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe("#renderComponent", () => {
    it("renders", () => {
      const renderComponent = instance.renderComponent()

      expect(renderComponent).toBeTruthy()
    })
  })

  describe("#renderTabs", () => {
    it("renders", () => {
      const renderTabs = instance.renderTabs()

      expect(renderTabs).toBeTruthy()
    })
  })
})
